export enum SubscriptionCacheTags {
  SUBSCRIPTIONS = 'SUBSCRIPTIONS',
  SUBSCRIPTION_DETAIL = 'SUBSCRIPTION_DETAIL',
}

export enum BillingCycle {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  FIRST_OF_MONTH = 'FIRST_OF_MONTH',
  FIRST_OF_YEAR = 'FIRST_OF_YEAR',
}

export enum AutoRenewalStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
